import React from 'react';

import type { IdentityBlockConfig, PipelineBlock } from '@mai/types';

interface IdentityBlockEditorProps {
  block: PipelineBlock & { type: 'identity' };
  onConfigChange: (config: IdentityBlockConfig) => void;
}

export const IdentityBlockEditor: React.FC<IdentityBlockEditorProps> = () => {
  return (
    <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>
      This block requires no configuration.
    </div>
  );
};
